import type { TasApprovable } from './tas-approvable.type.ts';
export interface TasApprovableExtension extends TasApprovable {}
export class TasApprovableExtension {
  /*************************
   **  Computed Properties **
   *************************/
  // NOTE: AFFIRMED and NOT_AFFIRMED are transitory states.
  // They auto-cascade and should never be seen at rest.
  // PREPARING = "changes needed" (employee must act after denial)
  // PENDING = "under review" (reviewer must act)
  get isPreparing() {
    return this.state === 'ApprovableState.PREPARING';
  }

  get isPending() {
    return this.state === 'ApprovableState.PENDING';
  }

  get isInReview() {
    return this.isPreparing || this.isPending;
  }

  get isApproved() {
    return this.state === 'ApprovableState.APPROVED';
  }

  get isRejected() {
    return this.state === 'ApprovableState.REJECTED';
  }

  get isAbandoned() {
    return this.state === 'ApprovableState.ABANDONED';
  }

  get isCourseCashUsageReview() {
    return this.approval === 'ApprovalType.COURSE_CASH_USAGE_REVIEW';
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-approvable',
  features: TasApprovableExtension,
};
export default Registration;
